import {
  REGISTRATION_DATA_LOADED,
  REGISTRATION_SUCCEEDED
} from "../constants/ActionTypes";

export const INITIAL_STATE = {
  loaded: false,
  registered: false,
  data: undefined,
  profile: undefined,
  profileErrorMessage: undefined
};

const registration = (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case REGISTRATION_DATA_LOADED:
      if (action.data === undefined) {
        return {
          ...state,
          loaded: true,
          profileName: action.profileName,
          profileErrorMessage: action.errorMessage
        };
      }       

      const {
        name,
        additional_fields,
        help_text,
        custom_support_enabled,
        support_url
      } = action.data;

      return {
        ...state,
        data: {
          name,
          additionalFields: additional_fields || [],
          helpText: help_text,
          customSupportEnabled: custom_support_enabled,
          supportUrl: support_url,
        },
        loaded: true,
        profileName: action.profileName,
        profileErrorMessage: undefined
      };
    
    case REGISTRATION_SUCCEEDED:
      return {
        ...state,
        registered: {
          success: true,
          type: action.registration_type, 
          data: action.registration_data 
        }
      };

    default:
      return state;
  }
};

export default registration;
